export default __webpack_public_path__ + "static/media/lifeleech3.89caaafa.png";